export const CONFIG = {
  URL: import.meta.env.VITE_URL,
  ENV: import.meta.env.VITE_ENV,
  EQ_API_URL: import.meta.env.VITE_EQ_API_URL,
  EQ_APP_URL: import.meta.env.VITE_EQ_APP_URL,
  LAUNCH_DARKLY_CLIENT_ID: import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_ID,
  SMARTY_EMBEDDED_KEY: import.meta.env.VITE_SMARTY_EMBEDDED_KEY,
  PERSONA_ENV: import.meta.env.VITE_PERSONA_ENV,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  SENTRY_ENV: import.meta.env.VITE_SENTRY_ENV,
  SKYFLOW_VAULT_ID: import.meta.env.VITE_SKYFLOW_VAULT_ID,
  SKYFLOW_VAULT_URL: import.meta.env.VITE_SKYFLOW_VAULT_URL,
  FULLSTORY_ORG_ID: import.meta.env.VITE_FULLSTORY_ORG_ID,
};

export const isProduction = () => CONFIG.ENV === "production";
